module.exports = __webpack_public_path__ + "img/4.bff3135f.png";